export const lightGroupsConfig = {
    subsolo01: [
      {
        id: "grupo15",
        modulo: "4",
        idx: "3",
        descricao: "Circuito 15",
        lightType: "normal",
        instances: [
          // fileira 1 (norte)
          { x: 25, y: 15, width: 2.5, height: 5, circleNumber: 15 },
          { x: 50, y: 15, width: 2.5, height: 5, circleNumber: 15 },
          { x: 75, y: 15, width: 2.5, height: 5, circleNumber: 15 },

          // fileira 2
          { x: 25, y: 30, width: 2.5, height: 5, circleNumber: 15 },
          { x: 50, y: 30, width: 2.5, height: 5, circleNumber: 15 },
          { x: 75, y: 30, width: 2.5, height: 5, circleNumber: 15 },

          // fileira 3 (centro)
          { x: 25, y: 45, width: 2.5, height: 5, circleNumber: 15 },
          { x: 50, y: 45, width: 2.5, height: 5, circleNumber: 15 },
          { x: 75, y: 45, width: 2.5, height: 5, circleNumber: 15 },

          // fileira 4
          { x: 25, y: 60, width: 2.5, height: 5, circleNumber: 15 },
          { x: 50, y: 60, width: 2.5, height: 5, circleNumber: 15 },
          { x: 75, y: 60, width: 2.5, height: 5, circleNumber: 15 },

          // fileira 5 (sul)
          { x: 25, y: 75, width: 2.5, height: 5, circleNumber: 15 },
          { x: 50, y: 75, width: 2.5, height: 5, circleNumber: 15 },
          { x: 75, y: 75, width: 2.5, height: 5, circleNumber: 15 },

          // reforços laterais (corredores)
          { x: 10, y: 30, width: 2.5, height: 5, circleNumber: 15 },
          { x: 10, y: 60, width: 2.5, height: 5, circleNumber: 15 },
          { x: 90, y: 30, width: 2.5, height: 5, circleNumber: 15 },
          { x: 90, y: 60, width: 2.5, height: 5, circleNumber: 15 }
        ]
      },

    ],
  };
  